import { Outlet, useLocation } from 'react-router';
import WelcomeBanner from './_components/welcome-banner';
import PageWrapper from '@/routes/page-wrapper';

const AuthLayout = () => {
  const location = useLocation();

  return (
    <PageWrapper isTransition>
      <div className="h-full lg:h-screen flex-wrap lg:flex-nowrap flex lg:items-center justify-center p-4">
        <div className="login-bg h-full rounded-[12px] p-6 lg:p-4 py-6 lg:py-4 my-0 lg:my-8 w-full lg:w-2/5  mx-auto text-center">
          <WelcomeBanner />
        </div>
        <div 
        className={`h-auto overflow-auto custom-scroll ${
          location.pathname === '/register' ? 'lg:items-start ' : 'lg:items-center'
        } lg:h-full p-0 lg:p-4 my-0 lg:my-8 w-full lg:w-3/5 mx-auto lex-wrap lg:flex-nowrap flex justify-center`}
        >
          <div
            className={`px-0 flex ${
              location.pathname === '/register' ? 'justify-start' : 'justify-center'
            } w-full flex-col lg:px-8 xl:px-20 h-full 2xl:h-auto overflow-auto custom-scroll`}
          >
            <PageWrapper onRouteChange isTransition><Outlet /></PageWrapper>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AuthLayout;
